export default __webpack_public_path__ + "static/media/sun.a278364f.svg";